import { useQuery } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { fetchAddressSuggestionsWithValidation } from '../utils/address';

export const useAddressAutocomplete = (input: string) => {
  const [debouncedInput, setDebouncedInput] = useState(input);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedInput(input);
    }, 300);

    return () => clearTimeout(timer);
  }, [input]);

  const { data: suggestions = [], isLoading, error } = useQuery({
    queryKey: ['addressSuggestions', debouncedInput],
    queryFn: () => fetchAddressSuggestionsWithValidation(debouncedInput),
    enabled: debouncedInput.length >= 3,
    staleTime: 15 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    suggestions,
    isLoading,
    error,
  };
};
